const STORAGE_KEY = 'akt_app_notifications';
const ARCHIVE_DAYS = 7;

export interface AppNotification {
  notification_id: number;
  account_owner_id: number;
  type: string;
  title: string;
  message: string;
  actor_user_id: number;
  actor_name: string;
  is_read: number;
  is_archived: number;
  created_at: string;
}

function getAll(): AppNotification[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch { return []; }
}

function saveAll(notifications: AppNotification[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(notifications));
}

function nextId(list: AppNotification[]): number {
  if (list.length === 0) return 1;
  return Math.max(...list.map(n => n.notification_id)) + 1;
}

function nowISO(): string {
  return new Date().toISOString().replace('T', ' ').slice(0, 19);
}

export function addNotification(params: {
  account_owner_id: number;
  type: string;
  title: string;
  message: string;
  actor_user_id: number;
  actor_name: string;
}): void {
  if (params.actor_user_id === params.account_owner_id) return;
  const all = getAll();
  all.push({
    notification_id: nextId(all),
    account_owner_id: params.account_owner_id,
    type: params.type,
    title: params.title,
    message: params.message,
    actor_user_id: params.actor_user_id,
    actor_name: params.actor_name,
    is_read: 0,
    is_archived: 0,
    created_at: nowISO(),
  });
  saveAll(all);
}

export function getActiveNotifications(accountOwnerId: number): AppNotification[] {
  archiveOld();
  return getAll()
    // eslint-disable-next-line eqeqeq
    .filter(n => n.account_owner_id == accountOwnerId && n.is_archived !== 1)
    .sort((a, b) => b.created_at.localeCompare(a.created_at));
}

export function getUnreadCount(accountOwnerId: number): number {
  archiveOld();
  // eslint-disable-next-line eqeqeq
  return getAll().filter(n => n.account_owner_id == accountOwnerId && n.is_read !== 1 && n.is_archived !== 1).length;
}

export function markAsRead(notificationId: number): void {
  const all = getAll();
  // eslint-disable-next-line eqeqeq
  const idx = all.findIndex(n => n.notification_id == notificationId);
  if (idx >= 0) {
    all[idx].is_read = 1;
    saveAll(all);
  }
}

export function markAllAsRead(accountOwnerId: number): void {
  const all = getAll();
  all.forEach(n => {
    // eslint-disable-next-line eqeqeq
    if (n.account_owner_id == accountOwnerId && n.is_read !== 1) {
      n.is_read = 1;
    }
  });
  saveAll(all);
}

function archiveOld(): void {
  const all = getAll();
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - ARCHIVE_DAYS);
  const cutoffStr = cutoff.toISOString().replace('T', ' ').slice(0, 19);
  let changed = false;
  all.forEach(n => {
    if (n.is_archived !== 1 && n.created_at < cutoffStr) {
      n.is_archived = 1;
      changed = true;
    }
  });
  if (changed) saveAll(all);
}
